// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import componentsReducer, { ComponentsActions } from "@store/Extensions/Store/Components/ComponentsReducer";
import mergeReducer from "@toolkit/Framework/Common/Utilities/redux/mergeReducer";

reducers.components = mergeReducer(reducers.components, componentsReducer);

export type ExtendedActions = ComponentsActions;
